import {FC} from 'react';
import {PAYMENT_METHOD_OPTIONS, RegistrationPaymentMethod} from '../../model';
import {StepLayout} from 'features/registration';
import {PaymentMethodOption} from '../components/PaymentMethodOption/PaymentMethodOption';
import styles from './PaymentMethodStep.module.css';

type Props = {
	onChange: (value: RegistrationPaymentMethod) => void;
	allowedMethods?: RegistrationPaymentMethod[];
};

export const PaymentMethodStep: FC<Props> = ({onChange, allowedMethods}) => {
	const options = allowedMethods
		? PAYMENT_METHOD_OPTIONS.filter((option) => allowedMethods.includes(option.value))
		: PAYMENT_METHOD_OPTIONS;

	return (
		<StepLayout>
			<StepLayout.Title>Добавьте способ получения оплат</StepLayout.Title>

			<StepLayout.Content className={styles.list}>
				{options.map((option) => (
					<PaymentMethodOption
						key={option.value}
						value={option.value}
						label={option.label}
						onSelect={onChange}
					/>
				))}
			</StepLayout.Content>
		</StepLayout>
	);
};
